var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.302,
    height: 45,
    viewBox: "0 0 135.302 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rise_white_logo_160x45",
    "data-name": "Rise white logo 160x45",
    transform: "translate(-91.498 -56.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14008",
    "data-name": "Group 14008",
    transform: "translate(97.147 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M160.513,56.5q.231,0,.151.2a13.024,13.024,0,0,0-1.21,1.513,8.934,8.934,0,0,1-7.212,5.8q-2.371.1-4.741,0A22.926,22.926,0,0,1,160.513,56.5Z",
    transform: "translate(-147.5 -56.5)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.975
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14009",
    "data-name": "Group 14009",
    transform: "translate(92.81 56.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M128.81,56.5a20.209,20.209,0,0,1,12.1,5.094l-11.7.1a8.763,8.763,0,0,0-6.1,3.48,27.755,27.755,0,0,1-2.017,3.329,8.877,8.877,0,0,1-6,3.077q-5.3.076-10.592.05a20,20,0,0,1,2.421-5.145q4.337-.126,8.675-.151a8.849,8.849,0,0,0,6.1-3.984A9.177,9.177,0,0,1,128.81,56.5Z",
    transform: "translate(-104.5 -56.5)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.978
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14010",
    "data-name": "Group 14010",
    transform: "translate(91.498 63.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M119.541,130.444q6.1-.025,12.206.05a23.415,23.415,0,0,1,3.329,5.094q-8.276.079-16.543.252a8.573,8.573,0,0,0-5.195,3.379,27.756,27.756,0,0,1-2.017,3.329,9.11,9.11,0,0,1-5.5,2.976q-7.162.076-14.324.05a20.929,20.929,0,0,1,.605-5.094l13.315-.1a8.771,8.771,0,0,0,6.506-3.984A9.125,9.125,0,0,1,119.541,130.444Z",
    transform: "translate(-91.498 -130.437)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.983
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14011",
    "data-name": "Group 14011",
    transform: "translate(177.482 64.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M949.761,133.488q3.986-.074,3.177,3.833a2.741,2.741,0,0,1-1.765,1.463,3.047,3.047,0,0,1-2.976-.857,3.236,3.236,0,0,1-.2-3.228A2.941,2.941,0,0,1,949.761,133.488Z",
    transform: "translate(-947.659 -133.486)",
    fill: "#f8f8f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14012",
    "data-name": "Group 14012",
    transform: "translate(152.518 65.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M699.584,146.444q4.59-.025,9.179.05a15.735,15.735,0,0,1,5.649,1.11,7.089,7.089,0,0,1,4.287,5.9q.723,6.7-5.5,9.23,4.048,6.381,8.171,12.71l-.1.1q-2.724.1-5.447,0-3.512-5.687-6.91-11.449-2.283-.15-4.59-.1.025,5.75-.05,11.5a27.912,27.912,0,0,1-4.741,0Q699.408,160.959,699.584,146.444Zm4.741,4.237q2.27-.025,4.539.05,6.172.525,4.489,6.506a3.889,3.889,0,0,1-2.976,2.371,32.2,32.2,0,0,1-6.052.353Z",
    transform: "translate(-699.481 -146.437)",
    fill: "#fafafa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14013",
    "data-name": "Group 14013",
    transform: "translate(91.599 71.428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M121.955,205.444q7.515-.025,15.03.05a19.7,19.7,0,0,1,1.11,5.094q-7.868-.025-15.736.05a8.845,8.845,0,0,0-6.2,3.581,27.754,27.754,0,0,1-2.017,3.329,8.872,8.872,0,0,1-5.8,2.976q-7.364.076-14.727.05a34.1,34.1,0,0,1-1.11-5.044q7.514-.126,15.03-.151a8.769,8.769,0,0,0,7.212-3.984A9.45,9.45,0,0,1,121.955,205.444Z",
    transform: "translate(-92.5 -205.437)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.986
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14014",
    "data-name": "Group 14014",
    transform: "translate(187.577 72.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M1048.759,234.437a40.246,40.246,0,0,1,.1-4.035,20.909,20.909,0,0,0,7.061,1.715,10.711,10.711,0,0,0,2.724-.454,2.181,2.181,0,0,0,1.362-2.673,2.61,2.61,0,0,0-1.362-1.564,42,42,0,0,0-5.044-2.219,17.882,17.882,0,0,1-2.724-1.513,5.83,5.83,0,0,1-1.967-6.708,6.081,6.081,0,0,1,3.581-3.278,16.937,16.937,0,0,1,11.953.857,29.783,29.783,0,0,1-1.463,3.581.428.428,0,0,1-.4,0,14.323,14.323,0,0,0-6.557-1.311,4.589,4.589,0,0,0-2.017.605,1.986,1.986,0,0,0,.605,3.228q3.09,1.45,6.254,2.724,5.131,2.42,3.682,7.919a6.381,6.381,0,0,1-4.489,3.984,19.452,19.452,0,0,1-10.491-.4A1.832,1.832,0,0,1,1048.759,234.437Z",
    transform: "translate(-1048.563 -213.001)",
    fill: "#fafafa",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14015",
    "data-name": "Group 14015",
    transform: "translate(207.29 72.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M1254.411,212.167a9.559,9.559,0,0,1,8.019,3.026,10.048,10.048,0,0,1,2.118,5.245q.1,2.118,0,4.237-7.227.151-14.475.1a7.409,7.409,0,0,0,1.664,4.741,5.846,5.846,0,0,0,3.379,1.564,15.851,15.851,0,0,0,8.221-1.463.4.4,0,0,1,.2.1,34.356,34.356,0,0,1,0,3.732,12.161,12.161,0,0,1-4.892,1.463,17.881,17.881,0,0,1-6.254-.3,9.684,9.684,0,0,1-7.011-7.616,17.3,17.3,0,0,1,.706-8.978A9.183,9.183,0,0,1,1254.411,212.167Zm.3,3.732q5.173.13,5.145,5.346h-9.684a7.223,7.223,0,0,1,1.463-3.934A4.992,4.992,0,0,1,1254.714,215.9Z",
    transform: "translate(-1245.089 -212.13)",
    fill: "#f9f9f9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14016",
    "data-name": "Group 14016",
    transform: "translate(177.767 72.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M950.584,216.392q2.357-.049,4.691.1.126,10.981-.05,21.94a36.713,36.713,0,0,1-4.691-.05Q950.408,227.377,950.584,216.392Z",
    transform: "translate(-950.482 -216.38)",
    fill: "#f8f8f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14017",
    "data-name": "Group 14017",
    transform: "translate(93.819 78.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M144.258,279.5h13.719a22.334,22.334,0,0,1-.5,5.245q-6.86-.025-13.719.05a8.734,8.734,0,0,0-6.1,3.884,9.987,9.987,0,0,1-3.783,4.691,9.024,9.024,0,0,1-3.329,1.21q-6.405.1-12.811,0a19.223,19.223,0,0,1-3.228-5.094q7.818.025,15.635-.05a8.541,8.541,0,0,0,5.8-3.177,21.1,21.1,0,0,0,1.715-2.925A9.258,9.258,0,0,1,144.258,279.5Z",
    transform: "translate(-114.5 -279.5)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14018",
    "data-name": "Group 14018",
    transform: "translate(99.568 86.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M197.021,354.388q5.5-.05,11,.1a20.5,20.5,0,0,1-2.522,4.993l-8.07.1a8.762,8.762,0,0,0-6.607,3.984,9.793,9.793,0,0,1-3.682,4.59,8.954,8.954,0,0,1-4.287,1.362,22.329,22.329,0,0,1-11.348-5.094l11.3-.1a8.865,8.865,0,0,0,6.3-3.178q1.035-1.564,1.917-3.228A9.139,9.139,0,0,1,197.021,354.388Z",
    transform: "translate(-171.5 -354.375)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.986
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14019",
    "data-name": "Group 14019",
    transform: "translate(187.726 89.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M1049.7,384.6a40.247,40.247,0,0,0-.1,4.035,21.3,21.3,0,0,1,0-4.136A.111.111,0,0,1,1049.7,384.6Z",
    transform: "translate(-1049.503 -384.5)",
    fill: "#848484",
    fillRule: "evenodd",
    opacity: 0.627
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14020",
    "data-name": "Group 14020",
    transform: "translate(118.305 93.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M367.78,428.444q2.018-.025,4.035.05a21.494,21.494,0,0,1-13.315,7.465,10.168,10.168,0,0,0,1.362-1.664A9.012,9.012,0,0,1,367.78,428.444Z",
    transform: "translate(-358.5 -428.437)",
    fill: "#ff5300",
    fillRule: "evenodd",
    opacity: 0.97
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo-white.2f1849a005548afa454db2e95ba6ba8c.svg";
export { ForwardRef as ReactComponent };